/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'
import { get } from 'lodash'
/**
 * Import
 * - Store
 */
import { RootState } from '../../../store'

/**
 * Import
 * - Actions
 */
import { setStep03, resetQuotes, setStep03Renewals, getRenewalVariation, getQuoteVariation } from '../../../actions'

/**
 * Import
 * - Page component
 */
import Step03 from '../../../components/pages/Quote/Step03c/Step03c'

const mapStateToProps = (state: RootState, props: any) => {
    return {
        quote: state.quote,
        fullQuote: get(state.quote, 'full.response.quote', {}),
    }
}

export default connect(
    mapStateToProps,
    {
        setStep03: setStep03,
        setStep03Renewals: setStep03Renewals,
        resetQuotes: resetQuotes,
        getRenewalVariation,
        getQuoteVariation,
    }
)(Step03)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Quote/Step03c.tsx